// src/pages/GuideTailles.jsx
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const DATA = {
  Capes: [
    { taille: 'S/M', poitrine: '90–98 cm', longueur: '105 cm', hauteur: '155–165 cm' },
    { taille: 'L/XL', poitrine: '98–106 cm', longueur: '108 cm', hauteur: '160–170 cm' },
    { taille: 'XXL/XXXL', poitrine: '106–118 cm', longueur: '110 cm', hauteur: '165–175 cm' },
  ],
  Ensembles: [
    { taille: 'S/M', poitrine: '90–98 cm', longueur: '105 cm', hauteur: '155–165 cm' },
    { taille: 'L/XL', poitrine: '98–106 cm', longueur: '108 cm', hauteur: '160–170 cm' },
    { taille: 'XXL/XXXL', poitrine: '106–118 cm', longueur: '110 cm', hauteur: '165–175 cm' },
  ],
  Abayas: [
    { taille: 'S/M', poitrine: '90–98 cm', longueur: '135 cm', hauteur: '155–165 cm' },
    { taille: 'L/XL', poitrine: '98–106 cm', longueur: '140 cm', hauteur: '160–170 cm' },
    { taille: 'XXL/XXXL', poitrine: '106–118 cm', longueur: '145 cm', hauteur: '165–175 cm' },
  ],
  Burkinis: [
    { taille: 'S', poitrine: '82–88 cm', longueur: '85 cm', hauteur: '150–160 cm' },
    { taille: 'M', poitrine: '88–94 cm', longueur: '88 cm', hauteur: '158–168 cm' },
    { taille: 'L', poitrine: '94–100 cm', longueur: '92 cm', hauteur: '165–175 cm' },
  ],
};

const TABS = [
  { key: 'Capes',     labelKey: 'guide.tabCapes' },
  { key: 'Ensembles', labelKey: 'guide.tabSets' },
  { key: 'Abayas',    labelKey: 'guide.tabAbayas' },
  { key: 'Burkinis',  labelKey: 'guide.tabBurkinis' },
];

function GuideTailles() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('Capes');

  return (
    <main className="guide-page">
      <header className="page-hero">
        <div className="page-hero__inner">
          <span className="page-hero__label">{t('guide.heroLabel')}</span>
          <h1 className="page-hero__title">{t('guide.heroTitle')}</h1>
          <p className="page-hero__subtitle">{t('guide.heroSubtitle')}</p>
        </div>
      </header>

      <section className="guide-content">
        <div className="guide-tabs">
          {TABS.map(tab => (
            <button
              key={tab.key}
              className={`guide-tab ${activeTab === tab.key ? 'is-active' : ''}`}
              onClick={() => setActiveTab(tab.key)}
            >
              {t(tab.labelKey)}
            </button>
          ))}
        </div>

        <div className="guide-table-wrap">
          <table className="guide-table">
            <thead>
              <tr>
                <th>{t('guide.thSize')}</th>
                <th>{t('guide.thChest')}</th>
                <th>{t('guide.thLength')}</th>
                <th>{t('guide.thHeight')}</th>
              </tr>
            </thead>
            <tbody>
              {DATA[activeTab].map((row, i) => (
                <tr key={i}>
                  <td><strong>{row.taille}</strong></td>
                  <td>{row.poitrine}</td>
                  <td>{row.longueur}</td>
                  <td>{row.hauteur}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <p className="guide-note">{t('guide.note')}</p>
        </div>

        <div className="guide-measure">
          <h2>{t('guide.measureTitle')}</h2>
          <div className="guide-measure__grid">
            <div className="guide-measure__item">
              <div className="guide-measure__num">1</div>
              <h3>{t('guide.measure1Title')}</h3>
              <p>{t('guide.measure1Text')}</p>
            </div>
            <div className="guide-measure__item">
              <div className="guide-measure__num">2</div>
              <h3>{t('guide.measure2Title')}</h3>
              <p>{t('guide.measure2Text')}</p>
            </div>
            <div className="guide-measure__item">
              <div className="guide-measure__num">3</div>
              <h3>{t('guide.measure3Title')}</h3>
              <p>{t('guide.measure3Text')}</p>
            </div>
          </div>
        </div>

        <div className="guide-cta">
          <p>{t('guide.ctaText')}</p>
          <a href="https://wa.me/212669428878?text=Bonjour%2C%20j%27aimerais%20un%20conseil%20taille" target="_blank" rel="noreferrer" className="btn btn-primary">
            {t('guide.ctaButton')}
          </a>
        </div>
      </section>
    </main>
  );
}

export default GuideTailles;